const options = [
  {
    id: "1",
    label: "Niagara Falls",
    slug: "Niagara-Falls",
  },
  {
    id: "2",
    label: "Ottawa",
    slug: "Ottawa",
  },
  {
    id: "3",
    label: "Haldimand",
    slug: "Haldimand",
  },
  {
    id: "4",
    label: "Markham",
    slug: "Markham",
  },
  {
    id: "5",
    label: "Durham",
    slug: "Durham",
  },
  {
    id: "6",
    label: "Waterloo",
    slug: "Waterloo",
  },
];

export default options;
